import { Card, CardContent, CardHeader, Chip, Stack } from "@mui/material";
import { ProductMetadata } from "../hooks/ProductApiHook";
import MaturityIndicator from "./MaturityIndicator";
import { useNavigate } from "react-router";

interface ScoreCardProps {
  product: ProductMetadata;
}

const ScoreCard: React.FC<ScoreCardProps> = ({ product }) => {
  const navigate = useNavigate();
  //If we ever add a new value we have to add the title here or everything with break
  const gaugeOrder = [
    "Dynamic Security Testing",
    "Security Champion",
    "Snyk Code",
    "Snyk Open Source",
  ] as const;

  return (
    <Card id={`product-${product.id}`}>
      <CardHeader title={product.name} />
      <CardContent>
        <Stack spacing={1} >
          <Stack direction={"row"} spacing={2} useFlexGap sx={{ flexWrap: 'wrap' }}>
            {product.attributes != null && [...product.attributes]
              .sort((a, b) => a.name.localeCompare(b.name) || a.value.localeCompare(b.value))
              .map((data) => (
              <Chip key={data.name} label={data.name + ": " + data.value}></Chip>
            ))}
          </Stack>
          <Stack direction="row" spacing={2}>
            {product.scores &&
              [...product.scores]
                .sort((a, b) =>
                  gaugeOrder.indexOf(a.name as typeof gaugeOrder[number]) -
                  gaugeOrder.indexOf(b.name as typeof gaugeOrder[number])
                )
                .map(data => (
                  <MaturityIndicator
                    data={data}
                    key={data.name}

                    onClick={() => {
                      try {
                        localStorage.setItem('homeScrollToProductId', product.id);
                      } catch {
                      }

                      switch (data.name) {
                        case "Dynamic Security Testing":
                          navigate(`/issues/af/${product.id}`);
                          break;
                        case "Snyk Code":
                          navigate(`/issues/snyk/code/${product.id}`);
                          break;
                        case "Snyk Open Source":
                          navigate(`/issues/snyk/source/${product.id}`);
                          break;
                        default:
                          break;
                      }
                    }
                    }
                  />
                ))}
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  )
}
export default ScoreCard;
